import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://argwecoxrgqmvuzwuzrx.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFyZ3dlY294cmdxbXZ1end1enJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMyOTU0ODksImV4cCI6MjA5ODg3MTQ4OX0.EKA_p7ucyxFCib7qXzuG76j0JgivzPKBFE7_7HEbuPI';

// Safety timeout so a hung network request can never leave the app stuck
// on a loading spinner forever. The promise rejects and the calling
// component's finally-block runs, showing its error + "Try Again" UI.
const SUPABASE_TIMEOUT_MS = 15000;

const supabaseFetch: typeof fetch = async (input, init) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), SUPABASE_TIMEOUT_MS);

  // Preserve any caller-provided abort signal
  if (init?.signal) {
    if (init.signal.aborted) {
      controller.abort();
    } else {
      init.signal.addEventListener('abort', () => controller.abort(), { once: true });
    }
  }

  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } finally {
    clearTimeout(timeoutId);
  }
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    fetch: supabaseFetch,
  },
});
